export const mapLanguageStr = (lang: string) => {
    let languageString = '';
    if (lang.includes('es')) {
        languageString = 'es';
    } else if (lang.includes('en')) {
        languageString = 'en';
    } else {
        languageString = lang;
    }

    return languageString;
};
